/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaPlus: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="plus" viewBox="0 0 12 12">
      <path
        d="M6.66669 5.33341H10.6667C11.0347 5.33341 11.3334 5.63208 11.3334 6.00008C11.3334 6.36808 11.0347 6.66675 10.6667 6.66675H6.66669V10.6667C6.66669 11.0347 6.36802 11.3334 6.00002 11.3334C5.63202 11.3334 5.33335 11.0347 5.33335 10.6667V6.66675H1.33335C0.965354 6.66675 0.666687 6.36808 0.666687 6.00008C0.666687 5.63208 0.965354 5.33341 1.33335 5.33341H5.33335V1.33341C5.33335 0.965415 5.63202 0.666748 6.00002 0.666748C6.36802 0.666748 6.66669 0.965415 6.66669 1.33341V5.33341Z"
        fill="currentColor"
        stroke="currentColor"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaPlus)
